import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { Award } from '../clcd.service';
import Swiper from 'swiper';

@Component({
  selector: 'ag-clcd-awards',
  templateUrl: './awards.component.html',
  styleUrls: ['./awards.component.scss'],
})
export class AwardsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('swipe') componentRef: ElementRef<HTMLElement>;
  @ViewChild('swipeNext') swiperNext: ElementRef<HTMLElement>;
  @ViewChild('swipePrev') swiperPrev: ElementRef<HTMLElement>;
  @Input() awards: Award[];
  winners = ['winner', 'won', 'win'];
  finalists = ['finalist', 'runner up'];
  honors = ['honor'];

  private _swiper: Swiper;

  constructor() {}

  ngAfterViewInit(): void {
    this._swiper = new Swiper(this.componentRef.nativeElement, {
      centeredSlides: false,
      direction: 'horizontal',
      keyboard: true,
      observer: true,
      pagination: false,
      spaceBetween: 40,
      autoplay: false,
      navigation: {
        nextEl: this.swiperNext.nativeElement,
        prevEl: this.swiperPrev.nativeElement,
      },
      slidesPerView: 4,
      breakpoints: this._setResponsive(4),
      rewind: true,
      a11y: {
        enabled: true,
      },
    });
  }

  private _setResponsive(slides) {
    // these breakpoints start from highest to smallest depending on columns. Starting Slides use MAX WIDTH NOT MIN WIDTH.
    switch (slides) {
      case 1:
      case 2:
        return {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 4 },
          768: { slidesPerView: 5 },
          992: { slidesPerView: 1 },
          1200: { slidesPerView: 2 },
          1400: { slidesPerView: 2 },
          1700: { slidesPerView: 2 },
          2000: { slidesPerView: 2 },
        };
      case 3: // for columns 2-1-2 and 2-2-1. mobile breakpoint at 767.
        return {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 4 },
          768: { slidesPerView: 5 },
          992: { slidesPerView: 2 },
          1200: { slidesPerView: 2 },
          1400: { slidesPerView: 3 },
          1700: { slidesPerView: 3 },
          2000: { slidesPerView: 3 },
        };
      case 4:
        return {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 4 },
          768: { slidesPerView: 5 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 3 },
          1400: { slidesPerView: 4 },
          1700: { slidesPerView: 4 },
          2000: { slidesPerView: 4 },
        };
      case 5:
        return {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 4 },
          768: { slidesPerView: 5 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
          1400: { slidesPerView: 5 },
          1700: { slidesPerView: 5 },
          2000: { slidesPerView: 5 },
        };
      case 6:
        return {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 4 },
          768: { slidesPerView: 5 },
          992: { slidesPerView: 4 },
          1200: { slidesPerView: 5 },
          1400: { slidesPerView: 5 },
          1700: { slidesPerView: 6 },
          2000: { slidesPerView: 6 },
        };
      case 7: // for columns 2-1-2 and 2-2-1. mobile breakpoint at 767.
        return {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 4 },
          768: { slidesPerView: 5 },
          992: { slidesPerView: 4 },
          1200: { slidesPerView: 4 },
          1400: { slidesPerView: 5 },
          1700: { slidesPerView: 6 },
          2000: { slidesPerView: 7 },
        };
      case 8: // for columns 2-1-3 and 2-3-1. mobile breakpoint at 767, also increased 950.
        return {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 4 },
          768: { slidesPerView: 5 },
          992: { slidesPerView: 4 },
          1200: { slidesPerView: 5 },
          1400: { slidesPerView: 6 },
          1700: { slidesPerView: 7 },
          2000: { slidesPerView: 8 },
        };
      default:
        // 1 column settings. Does not respond to normal breakpoints.
        return {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          640: { slidesPerView: 4 },
          768: { slidesPerView: 5 },
          992: { slidesPerView: 6 },
          1200: { slidesPerView: 7 },
          1400: { slidesPerView: 8 },
          1700: { slidesPerView: 9 },
          2000: { slidesPerView: 10 },
        };
    }
  }

  getAwardClass(status: string) {
    // Colors Status
    if (status.toLowerCase().includes('gold')) {
      return 'gold';
    }
    if (status.toLowerCase().includes('silver')) {
      return 'silver';
    }
    if (status.toLowerCase().includes('bronze')) {
      return 'bronze';
    }
    if (this.winners.some((winner) => status.toLowerCase().includes(winner))) {
      return 'winner';
    }
    if (this.finalists.some((finalist) => status.toLowerCase().includes(finalist))) {
      return 'finalist';
    }
    if (this.honors.some((honor) => status.toLowerCase().includes(honor))) {
      return 'honor';
    }
    return 'default';
  }

  ngOnDestroy(): void {
    this._swiper.destroy();
  }
}
